<template>
  <form @submit.prevent="submitForm">
    <div v-if="details.length === 0">
      <preloader n="7"/>
    </div>
    <div v-for="(detail, index) in details" :key="index" class="card">
      <div class="card-image">
        {{ detail.group.name }}
        <input type="hidden" v-model="detail.group_id" />
      </div>
      <div class="card-content">
        <div class="form-group">
          <label :for="'risk'+detail.id">{{$t('primary_inspections.details.risk')}}</label>
          <select :id="'risk'+detail.id" v-model="detail.risk" class="form-control" select-picker>
            <option v-for="(label, value) in translatedRisks" :key="value" :value="value">
              {{ label }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>{{$t('primary_inspections.details.pests')}}</label>
          <template v-for="pest in detail.group.pests">
            <label  :for="'pest'+pest.id" :key="pest.id">
              <input type="checkbox" :id="'pest'+pest.id" v-model="detail.pests_ids" :value="pest.id" />
              <span>{{ pest.name }}</span>
            </label>
          </template>
          <label>
            <input type="checkbox" v-model="detail.pests_ids_other" />
             <span>{{$t('primary_inspections.details.pests_ids_other')}}</span>
          </label>
        </div>
        <div class="form-group" v-if="detail.pests_ids_other">
          <label for="other">{{$t('primary_inspections.details.pests_ids_other')}}</label>
          <input type="text" v-model="detail.other" class="form-control" />
        </div>
        <div class="form-group">
          <label :for="'where'+detail.id">{{$t('primary_inspections.details.where')}}</label>
          <textarea :id="'where'+detail.id" type="text" v-model="detail.where" class="form-control" />
        </div>
        <div class="form-group">
          <label :for="'notions'+detail.id">{{$t('primary_inspections.details.notions')}}</label>
          <textarea :id="'notions'+detail.id" v-model="detail.notions" class="form-control"></textarea>
        </div>
        <div class="form-group">
          <label :for="'advices'+detail.id">{{$t('primary_inspections.details.advices')}}</label>
          <textarea :id="'advices'+detail.id" type="text" v-model="detail.advices" class="form-control" />
        </div>
        <div class="form-group">
          <label :for="'periods'+detail.id">{{$t('primary_inspections.details.periods')}}</label>
          <selector  v-model="detail.periods" :items="periods" identifier="kinds"></selector>
        </div>
        <div class="form-group">
          <label :for="'under_observation'+detail.id">{{$t('primary_inspections.details.under_observation')}}</label>
          <select :id="'under_observation'+detail.id" v-model="detail.under_observation" class="form-control">
            <option v-for="(label, value) in translatedUnderObservations" :key="value" :value="value">
              {{ label }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label :for="'observation'+detail.id">{{$t('primary_inspections.details.observation')}}</label>
          <select :id="'observation'+detail.id" v-model="detail.observation" class="form-control">
            <option v-for="(label, value) in translatedObservations" :key="value" :value="value">
              {{ label }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col s4 offset-s8" style="padding: 25px;">
        <button type="submit" class="btn btn-primary btn-lg active green">{{$t('menu.buttons.save')}}</button>
        <button type="button" @click="cancel" class="btn btn-primary btn-lg red">{{$t('menu.cancel')}}</button>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      form: {
        additional_info: "",
        conditions: "",
        class: "",
      },
      details: [],
      translatedRisks: {
        low: this.$t('primary_inspections.risk_list.low'),
        medium: this.$t('primary_inspections.risk_list.medium'),
        big: this.$t('primary_inspections.risk_list.big'),
        very_big: this.$t('primary_inspections.risk_list.very_big'),
      },
      periods: [
        {value: 'winter', name: this.$t('primary_inspections.winter')},
        {value: 'spring', name: this.$t('primary_inspections.spring')},
        {value: 'summer', name: this.$t('primary_inspections.summer')},
        {value: 'autumn', name: this.$t('primary_inspections.autumn')}
      ],
      translatedUnderObservations: {
        requires: this.$t('primary_inspections.under_observation_list.requires'),
        not_requires: this.$t('primary_inspections.under_observation_list.not_requires'),
      },
      translatedObservations: {
        accepted: this.$t('primary_inspections.observation_list.accepted'),
        refused: this.$t('primary_inspections.observation_list.refused'),
        pending: this.$t('primary_inspections.observation_list.pending'),
      }
    };
  },
  mounted() {
    this.fetchDetails();
  },
  methods: {
    async fetchDetails() {
      const url = `/customers/${this.$route.params.customer_id}/places/${this.$route.params.place_id}/primary_inspections/${this.$route.params.primary_inspection_id ? this.$route.params.primary_inspection_id : 'new'}.json`;
      try {
        const response = await axios.get(url); // Replace with your endpoint
        this.details = response.data.details || [];
      } catch (error) {
        console.error("Error fetching details:", error);
      }
    },
    submitForm() {
      var that = this;
      const url = `/customers/${this.$route.params.customer_id}/places/${this.$route.params.place_id}/primary_inspections${this.$route.params.primary_inspection_id ? '/'+this.$route.params.primary_inspection_id : ''}.json`;

      const method = this.$route.params.primary_inspection_id ? 'put' : 'post';

      axios[method](url, { primary_inspection: { details_attributes: this.details }})
        .then((response) => {
           that.$router.push('/customers/' + that.$route.params.customer_id + '/places/' + that.$route.params.place_id + '/primary_inspections/' + response.data.id )
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
        });
    },
    cancel() {
      if(!this.$route.params.primary_inspection_id){
        this.$router.push('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id )
      }else{
        this.$router.push('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/primary_inspections/' + this.$route.params.primary_inspection_id )
      }
    
    },
  },
};
</script>

<style scoped>
.card {
  margin: 20px !important;
}
.card-image {
  background-color: #f5f5f5;
  padding: 10px;
  font-weight: bold;
}
select {
    display: block;
    padding-top: 0px;
    padding-bottom: 0px 0px 0px 0px;
    height: 35px;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
}
</style>
